// extracted by mini-css-extract-plugin
export default {"footerImageWrapper":"footerImageWrapper--ePqgh"};